import { ComponentRef } from '../interface';

export function hasShadowDom(el: HTMLElement) {
  return !!el.shadowRoot && !!(el as any).attachShadow;
}

export function now(ev: UIEvent) {
  return ev.timeStamp || Date.now();
}

export const clamp = (min: number, n: number, max: number) => {
  return Math.max(min, Math.min(n, max));
};

export function renderHiddenInput(container: HTMLElement, name: string, value: string | undefined | null, disabled: boolean) {
  if (hasShadowDom(container)) {
    let input = container.querySelector('input.aux-input') as HTMLInputElement | null;
    if (!input) {
      input = container.ownerDocument!.createElement('input');
      input.type = 'hidden';
      input.classList.add('aux-input');
      container.appendChild(input);
    }
    input.disabled = disabled;
    input.name = name;
    input.value = value || '';
  }
}

export function isEmpty (obj: any) {
  return [Object, Array].includes((obj || {}).constructor) && !Object.entries((obj || {})).length;
}

export function pick(object, keys) {
  return keys.reduce((obj, key) => {
     if (object && object.hasOwnProperty(key)) {
        obj[key] = object[key];
     }
     return obj;
   }, {});
}

export function camelCasetoDashed(str: string) {
  return str.replace(/[A-Z]/g, m => '-' + m.toLowerCase());
}

export async function attachComponent(
  container: Element,
  component: ComponentRef,
  componentProps?: { [key: string]: any }
): Promise<HTMLElement> {
  if (typeof component !== 'string' && !(component instanceof HTMLElement)) {
    throw new Error('component is missing');
  }
  if (!container) {
    throw new Error('container is missing');
  }
  const el: any = (typeof component === 'string')
    ? container.ownerDocument && container.ownerDocument.createElement(component)
    : component;
  if (componentProps) {
    assignComponentProps(el, componentProps);
  }
  container.appendChild(el);
  if (el.componentOnReady) {
    await el.componentOnReady();
  }
  return el;
};

export function assignComponentProps(el: HTMLElement, componentProps: { [key: string]: any }) {
  if (componentProps) {
    Object.assign(el, componentProps);
  }
  // append onEventListener props
  for (const prop of Object.keys(componentProps)) {
    if (prop.match(/^on[A-Z][a-zA-Z0-9]*$/g)) {
      const eventName = prop.replace('on', '').toLowerCase() // onLarChange => larchange
      el.addEventListener(eventName, componentProps[prop]);
    }
  }
}